"use strict";

exports.__esModule = true;
exports.system = system;
exports.compose = compose;

var _lodash = _interopRequireDefault(require("lodash.mergewith"));

var _createParser = require("./create-parser");

var _createStyleFunction = require("./create-style-function");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function system(configs) {
  var config = {};
  Object.keys(configs).forEach(function (key) {
    var propConfig = configs[key];

    if (propConfig === true) {
      config[key] = (0, _createStyleFunction.createStyleFunction)({
        property: key,
        scale: key
      });
      return;
    }

    if (typeof propConfig === "function") {
      config[key] = propConfig;
      return;
    }

    config[key] = (0, _createStyleFunction.createStyleFunction)(propConfig);
  });
  return (0, _createParser.createParser)(config);
}

function compose() {
  var config = {};

  for (var _len = arguments.length, parsers = new Array(_len), _key = 0; _key < _len; _key++) {
    parsers[_key] = arguments[_key];
  }

  parsers.forEach(function (parser) {
    if (!parser || !parser.config) return;
    config = (0, _lodash["default"])({}, config, parser.config);
  });
  var parser = (0, _createParser.createParser)(config);
  return parser;
}
//# sourceMappingURL=create-system.js.map